import React from "react";

import Diary from "../../components/diary-form/diary-form.component";

const DiaryPage = () => {
  return (
    <div>
      <Diary />
    </div>
  );
};

export default DiaryPage;
